var staticDecodeURIComponent = decodeURIComponent

module.exports = staticDecodeURIComponent



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/staticDecodeURIComponent.js
// module id = 517
// module chunks = 75